import { render, staticRenderFns } from "./Grid2.vue?vue&type=template&id=7b86e2cf&scoped=true&"
import script from "./Grid2.vue?vue&type=script&lang=ts&"
export * from "./Grid2.vue?vue&type=script&lang=ts&"
import style0 from "./Grid2.vue?vue&type=style&index=0&id=7b86e2cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b86e2cf",
  null
  
)

export default component.exports